import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePickerSimple from './DatePickerSimple';
import moment from 'moment';
import 'moment/locale/en-gb';
import './DatePicker.scss';

class DatePicker extends Component {
  state = {
    inputDate: undefined,
    minDate: undefined,
    maxDate: undefined,
  };
  static propTypes = {
    label: PropTypes.string,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object,
    fieldSize: PropTypes.string,
    labelSize: PropTypes.number,
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    minDateToday: PropTypes.bool,
    showYear: PropTypes.bool,
  };

  componentDidMount() {
    const { input, minDate, maxDate } = this.props;
    this.setState({
      inputDate: input && input.value ? new moment(input.value).toDate() : undefined,
      minDate: minDate ? new moment(minDate).toDate() : undefined,
      maxDate: maxDate ? new moment(maxDate).toDate() : undefined,
    });
  }

  onChange = (date) => {
    const { input } = this.props;
    if (input) {
      this.setState({
        inputDate: date,
      });
      if (date) {
        date.setHours(1); // move forward and hour in case of bst
        date.setUTCHours(0, 0, 0, 0); //set all times to 0
        input.onChange(date.toISOString());
      }
    }
  };

  render() {
    const {
      meta,
      minDateToday,
      showYear,
      onSelect,
      dateFormat,
      showTime = false,
      showMonthYearPicker,
      shouldCloseOnSelect,
    } = this.props;
    const { inputDate, minDate, maxDate } = this.state;

    return (
      <div className="datepicker-custom date-picker-one-month-container">
        <DatePickerSimple
          monthsShown={1}
          minDate={minDateToday ? moment().toDate() : minDate}
          maxDate={maxDate}
          showYear={showYear}
          showTime={showTime}
          dateFormat={dateFormat}
          selected={inputDate}
          onChange={this.onChange}
          onSelect={onSelect}
          showMonthYearPicker={showMonthYearPicker}
          shouldCloseOnSelect={shouldCloseOnSelect}
        />
        {meta && meta.touched && meta.error && (
          <div>
            <span className="input-error">{meta.error}</span>
          </div>
        )}
      </div>
    );
  }
}

export default DatePicker;
